import React, { useEffect, useState } from "react";
import {
  guidelinePageTabsSmallScreen,
  pbGuidelinePageTabsSmallScreen,
} from "../../features/guideline/guidelineTabs";
import styles from "./GuidelineNavApp.module.scss";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectMap } from "../../features/counter/counterSlice";
import generateMenuFromXml from "./guidelineMenuGenerator";
import { filterMenuItems } from "./filterMenuItems";
import classNames from "classnames";
import icons from "../../scss/guidelineicons.module.scss";
import useAppModernisation from "../../hooks/useAppModernisation";
import { MenuItem } from "./MenuItem";
import { isNullOrEmpty } from "../../utils/isNullOrEmpty";
import { isPregnancyAndBreastfeedingPage } from "../../utils/isPregnancyAndBreastfeedingPage";

const TabGroup = React.lazy(() => import("../../components/TabGroup/TabGroup"));

const GuidelineNavApp = ({ glObj }) => {
  const [currentTabId, setCurrentTabId] = useState("");
  const [tabs, setTabs] = React.useState([]);
  const { isAppMode } = useAppModernisation();
  const { pathname } = useLocation();
  const dartMap = useSelector(selectMap);
  const navigate = useNavigate();

  useEffect(() => {
    if (isPregnancyAndBreastfeedingPage(pathname)) {
      setTabs(pbGuidelinePageTabsSmallScreen);
      setCurrentTabId(pbGuidelinePageTabsSmallScreen[0].id);
    } else {
      setTabs(guidelinePageTabsSmallScreen);
      setCurrentTabId(guidelinePageTabsSmallScreen[0].id);
    }
  }, [pathname]);

  if (!glObj) {
    return null;
  }
  const parsed = generateMenuFromXml(`${dartMap}`);
  const { menuItems, rootGuideline, glInfo } = filterMenuItems({
    glObj,
    menuJson: parsed,
  });

  const iconClass = classNames(
    "squareIcon",
    { title: rootGuideline, subtitle: !rootGuideline },
    glInfo.iconClassSuffix,
  );

  const iconClassMobile = classNames(
    icons.squareIcon,
    { [icons.title]: rootGuideline, [icons.subtitle]: !rootGuideline },
    icons[glInfo.iconClassSuffix],
  );

  const topicMenus = menuItems?.items.filter(
    (props) => !props.msPath?.includes("-tables-boxes-figures"),
  );
  const chapterRoot = glObj.glPage.replaceAll(" ", "_");
  const goTopic = () => {
    if (isAppMode) {
      navigate(`/app/nav/${chapterRoot}`);
    } else {
      navigate(`/guidelines/${chapterRoot}`);
    }
  };

  // convert the guideline base path for quick links
  const getBaseInPath = (base) => {
    return base === "quicklinks" ? glInfo.onClickProps.replaceAll(" ", "_") : base;
  };

  if (rootGuideline) {
    return (
      <div className={styles.guidelineNavWrapper}>
        <div className={styles.iconContainer}>
          <div className={isAppMode ? iconClass : iconClassMobile} role="img"></div>
        </div>
        <h1 className={`size-36 regular ${styles.title}`}>{menuItems.title}</h1>
        <div className={styles.tabs}>
          {!isNullOrEmpty(tabs) && (
            <TabGroup
              key={tabs.map((t) => t.id).join("-")}
              tabs={tabs}
              defaultId={tabs && tabs[0]?.id}
              onTabChange={(id) => setCurrentTabId(id)}
            />
          )}
        </div>
        <div className={classNames(styles.menuContainer, styles.noTopBorder)}>
          {currentTabId === "topic" &&
            topicMenus?.map((props, index) => (
              <MenuItem
                {...props}
                key={`menu-${index}`}
                base={getBaseInPath(glObj.glPage)}
              ></MenuItem>
            ))}
        </div>
      </div>
    );
  } else {
    return (
      <div className={styles.guidelineNavWrapper}>
        <div className={styles.iconContainer}>
          <div className={isAppMode ? iconClass : iconClassMobile} role="img"></div>
          <div className="size-22 semibold" onClick={goTopic}>
            {glInfo.linkText}&nbsp;
            {glInfo.linkText && <span className="size-14 tg-icons-Carat"></span>}
          </div>
        </div>
        <h1 className={`size-36 regular ${styles.title}`}>{menuItems.title}</h1>
        <div className={styles.menuContainer}>
          {topicMenus?.map((props, index) => (
            <MenuItem
              {...props}
              key={`menu-${index}`}
              base={getBaseInPath(glObj.glPage)}
            ></MenuItem>
          ))}
        </div>
      </div>
    );
  }
};

export default GuidelineNavApp;
